import { render, staticRenderFns } from "./ClassPartDetail.vue?vue&type=template&id=7cc66b51"
import script from "./ClassPartDetail.vue?vue&type=script&lang=js"
export * from "./ClassPartDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports